<template>
  <FormSwitch v-model="value" size="is-small" @input="onInput">
    <template #default>
      <span class="is-size-6 has-text-weight-medium is-relative xy-t--1">
        {{ title }}
      </span>
    </template>
  </FormSwitch>
</template>

<script>
import FormSwitch from '@/modules/core/form/components/FormSwitch.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightSearchFilterItem',
  emits: ['on-filter'],
  components: { FormSwitch },
  props: {
    title: { type: String, required: true },
    filter: { type: String, required: true },
    defaultValue: { type: Boolean, required: true }
  },
  data() {
    return {
      value: this.defaultValue
    };
  },
  methods: {
    onInput(value) {
      this.$emit('on-filter', this.filter, value);
    }
  }
};
</script>
